<template>
  <div class="checkDetails">
    <div class="crumbs">
      <crumbs></crumbs>
    </div>
    <div class="guarantee" v-if="info">
      <div class="guerLeft">
        <div class="guerImgBox">
          <img :src="status[info.status].url" alt="" />
          <div>
            <i class="iconfont" :class="status[info.status].icon"></i>
            {{ info.statusTxt }}
          </div>
        </div>
      </div>
      <div class="guerRight">
        <div class="guerRightTop">
          <p>批单号：{{ info.correct_num ? info.correct_num : "暂无" }}</p>
          <p class="premium">
            保费：<span>{{ info.policy_money }}</span>
          </p>
        </div>
        <div class="guerRightMiddle">
          <p>流水号：{{ info.num_id }}</p>
          <p>保险公司：{{ info.companyName }}</p>
          <p>批改时间：{{ info.c_time }}</p>
          <p>产品名称：{{ info.productName }}</p>
          <p>保障期限：{{ info.s_time }} - {{ info.e_time }}</p>
          <p>提交人：{{ info.adminName }}</p>
        </div>
      </div>
    </div>
    <div class="contentBox">
      <div class="uploadStepBox">
        <div class="item">
          <div class="upSTit">
            <img src="@/assets/images/product/ziliaoxz.png" alt="" />
            <p>
              已生成批改资料
              <span>
                <i class="el-icon-warning-outline"></i>
                下载此批改资料，加盖公章后，再上传！
              </span>
            </p>
          </div>
          <div class="upSCon">
            <p>
              <a :href="info.correct_file">
                <i class="el-icon-download"></i> 批改资料
              </a>
            </p>
          </div>
        </div>
        <div class="item">
          <div class="upSTit">
            <img src="@/assets/images/product/ziliaoshagnc.png" alt="" />
            <p>上传批改资料</p>
          </div>
          <div class="upSCon">
            <el-upload
              drag
              action="/api/upload/upload"
              name="file"
              multiple
              :http-request="upload"
              :file-list="fileAttay"
              :on-remove="removeFile"
            >
              <img src="@/assets/images/product/upload.png" alt="" />
              <div>
                <div class="el-upload__text">
                  将批改资料拖到此处，或<em>点击上传</em>
                </div>
                <p>文件上传不得超过100M，支持pdf、word格式！</p>
              </div>
            </el-upload>
          </div>
        </div>
        <el-button type="primary" size="small" class="goPay" @click="goPay">
          上传批改资料
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getCorrection, uploadCorrectionFile } from "@/api/check";
import { upload } from "@/api/public";
import crumbs from "@/components/common/crumbs";
export default {
  name: "guaDdetails",
  components: {
    crumbs
  },
  data() {
    return {
      status: [],
      changeId: "",
      info: "", //订单详情
      fileAttay: []
    };
  },
  created() {
    this.status = this.$store.state.orderStatus;
    this.changeId = this.$route.query.changeId;
    this.getCorrection(); //获取订单详情
  },
  methods: {
    //获取批单详情
    getCorrection() {
      let that = this;
      getCorrection({ changeId: this.changeId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.info = res.data;
            // 设置title
            document.title = "上传资料--" + res.data.applicationName;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    //上传文件
    upload(e) {
      console.log(e);
      let that = this;
      let form = new FormData();
      form.append("file", e.file);
      form.append("folder", "other");
      upload(form)
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            let _data = { name: res.data.fileName, url: res.data.fileUrl };
            that.fileAttay.push(_data);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 移除
    removeFile(e, list) {
      console.log(e, list);
      let _array = [];
      list.forEach(element => {
        let _data = {
          name: element.name,
          url: element.url
        };
        _array.push(_data);
      });
      this.fileAttay = _array;
    },
    // 提交
    goPay() {
      let that = this;
      let _data = {
        changeId: that.changeId,
        fileUrl: []
      };
      that.fileAttay.forEach(element => {
        _data.fileUrl.push(element.url);
      });
      let loadind = that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      uploadCorrectionFile(_data)
        .then(function(res) {
          console.log(res);
          loadind.close();
          if (res.code == 1) {
            that.$message.success(res.msg);
            if (res.data.toTarget == "toPay") {
              that.$router.push({
                path: "/check/pay",
                query: { changeId: that.changeId }
              });
            } else {
              that.$router.push({
                path: "/check"
              });
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss">
.checkDetails {
  padding: 0 !important;
  margin-top: 15px !important;
  background: #f4f5f7 !important;
  box-shadow: none !important;
  & > .crumbs {
    margin: 0 8px;
  }
  & > .contentBox {
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.08);
    .uploadStepBox {
      padding-left: 120px;
      padding-right: 100px;
      padding-top: 35px;
      padding-bottom: 50px;
      & > .item {
        .upSTit {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          & > img {
            width: 40px;
            height: 40px;
            margin-right: 20px;
          }
          p {
            font-size: 20px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 28px;
            margin: 0;
            span {
              background: #fdf2d4;
              border-radius: 3px;
              display: inline-block;
              font-size: 14px;
              font-weight: 400;
              color: #f86c07;
              line-height: 20px;
              margin-left: 15px;
              padding: 6px 15px 6px 20px;
              i {
                font-size: 16px;
                color: #ee4039;
              }
            }
          }
        }
        .upSCon {
          position: relative;
          margin-top: 15px;
          margin-bottom: 45px;
          margin-left: 60px;
          & > p {
            margin: 0;
            padding: 10px 25px 13px;
            border: 1px solid #dedede;
            border-radius: 3px;
            & > a {
              display: block;
              font-size: 16px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              line-height: 25px;
              i {
                color: #2d8aee;
              }
            }
          }
          .el-upload {
            width: 100%;
            .el-upload-dragger {
              border: 1px solid #dedede;
              border-radius: 3px;
              width: 100%;
              height: 180px;
              background: #fcfcfc;
              display: flex;
              justify-content: center;
              align-items: center;
              img + div {
                margin: 0 50px;
                .el-upload__text {
                  font-size: 16px;
                  font-weight: 400;
                  color: #000000;
                  line-height: 22px;
                }
                p {
                  font-size: 12px;
                  margin: 5px 0 0;
                  font-weight: 400;
                  color: #f86c07;
                  line-height: 17px;
                }
              }
            }
          }
        }
        .upSCon::before {
          content: "";
          display: block;
          width: 1px;
          height: 110px;
          position: absolute;
          top: -16px;
          left: -40px;
          background: #8ea6bf82;
        }
      }
      & > .item + .item {
        .upSCon::before {
          display: none;
        }
      }
      .el-button.goPay {
        margin: 0 auto 35px;
        display: block;
      }
    }
  }
}
</style>
